import { format } from "date-fns";

export const parseFaixaHora = (faixa) => faixa ? faixa.split('T')[1].substring(0,5) : null;

export const parseData = (data) => { return data ? format(new Date(data), "dd/MM/yyyy") : null };

export const getHoraArredondada = (data, inicio) => {
  let dateTime = data ? {
    hora: format(new Date(data), "HH"),
    minuto: format(new Date(data), "ii")
  }: null;
  if(dateTime == null) return null;

  return inicio ? {
    hora: format(new Date(data), "HH"),
    minuto: format(new Date(data), "ii"),
   } : {
    hora: dateTime.hora
   };
};

export const formatCurrency = (valor) => {
  valor = parseFloat(valor);
  return isNaN(valor) ? '--' : valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

export const StatusQRCodes = {
  Iniciado: 0,
  PendentePagamento: 1,
  PendenteGeracao: 2,
  Disponivel: 3,
  Utilizado: 4,
  Expirado: 5,
  PagamentoRecusado: 6
}